// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__2Uo18","col":"styles_col__2DNC4"};